<div class="status-box">
  <img
    class="icon"
    src="{{ 'assets/images/dashboard/check-green.svg' | cheminAbsoluStatique }}"
    alt=""
    width="26"
    height="26"
  />
  <span class="text" [innerHTML]="textContent"></span>
</div>
